import { APP_BASE_HREF, DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AudioRecordingService } from '@app/_core/services/audio-recording.service';
import { CampaignService } from '@app/_core/services/campaign.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TextToSpeechService } from '@app/_core/services/text-to-speech.service';
import { MessageService } from 'primeng/api';
import { catchError, EMPTY } from 'rxjs';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { MainControllerComponent } from '@pages/queue/dialer/MainController.component';
import { lastValueFrom } from 'rxjs';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-new-campaign',
  templateUrl: './new-campaign.component.html',
  styleUrls: ['./new-campaign.component.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.Emulated,
})
export class NewCampaignComponent implements OnInit, OnDestroy {
  addnewCampaignForm: FormGroup;
  currentpath: any = '';
  phoneTypes = [];
  selectedType = '';
  phoneNumber: any = '';
  smsPhoneNumber: any = '';
  txtphonenumber: any;
  isReadOnly: boolean = true;
  isPublic: boolean = true;
  machineDetectionAllowed:boolean=false;
  channels: any = [];
  campaignTypes: any = [];
  callerIdInterval: any = '';
  status: any = [
    { label: 'Pending' },
    { label: 'Ready' },
    { label: 'Complete' },
    { label: 'Cancelled' },
    { label: 'Paused' },
    { label: 'InProgress' },
  ];
  callFrom: any = [];
  availableOnDays: any = [];
  timeZones: any = [];
  messageSources: any = [
    { label: 'Upload File', value: 'uploadfile', allowPreview: true },
    { label: 'Real-Time Recording', value: 'recording', allowPreview: true },
    { label: 'Text-to-Speech', value: 'texttospeech', allowPreview: true },
    { label: 'Custom API', value: 'customapi', allowPreview: false },
    {
      label: 'Custom IVR Message',
      value: 'customivrmessage',
      allowPreview: false,
    },
  ];
  responseQueues: any = [];
  responseQueueIVRPrompts: any = [];
  responseSkills: any = [];
  showAddMessage: boolean = false;
  selectedChannel: any;
  booleanOptions: any = [
    { label: 'True', value: true },
    { label: 'False', value: false },
  ];
  dataTypes: any = [{ label: 'File Upload' }, { label: 'Data Feed' }];
  TextSourceTypes: any = [{ label: 'Simple Message',value: false }, { label: 'Custom Message Feed',value: true }];
  selectedDays: number[] = [];
  isRecording: any;
  recordedTime: any;
  blobUrl: any;
  blobData: any;
  savingAudioFileMessage: any = '';
  savingDataFileMessage: any = '';
  savingRecordingFileMessage: any = '';
  fileToUpload: File | null = null;
  ivrPromptAPIMethods: any = [];
  phoneNumbers: any = [];
  timeIntervals: any = [
    { label: '1 minutes', value: 1 },
    { label: '3 minutes', value: 3 },
    { label: '5 minutes', value: 5 },
    { label: '10 minutes', value: 10 },
    { label: '15 minutes', value: 15 },
    { label: '30 minutes', value: 30 },
  ];
  campaignDetail: any;
  savedData: any;
  isEdit: boolean;
  selectedCampaignId: any;
  title: any;
  details: any;
  files: any = [];
  owner = 'group';
  object = 'user';
  priorities = false;
  persistence = false;
  roles = true;
  disableAllInputs: boolean = false;
  uploadedFiles: any = [];
  dataFileProcess: any = '';
  showFileDetails: boolean = false;
  appBaseUrl: any;
  updateFile: boolean = false;
  detailsViewData: any = [];
  progress: number = 0;
  timeValidationMessage: string;
  disableSaveBtn: boolean = false;
  addNewFile: boolean = false;
  showEditMessage: boolean = false;
  previewBtnText: string = 'Preview';
  private audio: HTMLAudioElement;
  showPreviewBtn: boolean = false;
  dataFileProcessStatus: string = '';
  fileNameMaxLenth: number = 35;
  disablePreviewBtn: boolean = true;
  savedCampaignDetail: any;
  lastSelectedMessageSource: string | null = null;
  audioBuffer: AudioBuffer;
  isSoftphoneOnly: boolean = false;
  isSoftphoneOnlyGrant: boolean;
  isTextChannelSelected: boolean = false;
  disableRefreshButton: boolean = false;
  submitted: boolean;
  modalRef?: BsModalRef;
  errorVoiceMsg: string;
  errorMsg: string;
  isMicMute: boolean = true;
  mutebtn_enabled: boolean = true;
  onHold: boolean = false;
  numberPad = [
    { number: '1' },
    { number: '2', digit: 'ABC' },
    { number: '3', digit: 'DEF' },
    { number: '4', digit: 'GHI' },
    { number: '5', digit: 'JKL' },
    { number: '6', digit: 'MNO' },
    { number: '7', digit: 'PQRS' },
    { number: '8', digit: 'TUV' },
    { number: '9', digit: 'WXYZ' },
    { number: '*' },
    { number: '0', digit: '*' },
    { number: '#' },
  ];
  keypad: any;
  dialbtn_enabled: boolean = true;
  calloptionWidth = 'calloption-hard-phone';
  txtphonenumberwidth = 'hard-phone';
  callDuraton: any = 0;
  callTimer: any;
  formattedCallDuration: any;   
  tempMsg:string='';
  stopRecordingTimeout: any;
  goBackTimeout: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private route: ActivatedRoute,
    private router: Router,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private location: Location,
    private fb: FormBuilder,
    private campaignService: CampaignService,
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer,
    private messageService: MessageService,
    private ttsService: TextToSpeechService,
    private appService: AppService,
    private cdr: ChangeDetectorRef,
    private webStorageService: WebStorageService,
    private modalService: BsModalService,
    private MainControllerComponent: MainControllerComponent
  ) {
    this.appBaseUrl = window.location.origin +'/'+ window.location.pathname.split('/')[1];
    //console.log('appBaseUrl', this.appBaseUrl);
    this.isEdit = false;
    this.audio = new Audio();
    this.route.params.subscribe((params: any) => {
     // console.log('params.id', params.id);
      if (params.id) {
        this.selectedCampaignId = Number(params.id);
        this.loadCampaignDetails(this.selectedCampaignId);
        this.isEdit = true;
      }
     // console.log('isEdit', this.isEdit);
    });

    // Audio

    this.audioRecordingService.recordingFailed().subscribe(() => (this.isRecording = false));
    this.audioRecordingService.getRecordedTime().subscribe(time => (this.recordedTime = time));
    this.audioRecordingService.getRecordedBlob().subscribe(data => {
      this.blobData = data;
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
    });
    this.campaignService.checkClientAllowsMachineDetection().subscribe(flag=>{
      if(flag) this.machineDetectionAllowed=flag;
    });
  }

  ngOnInit(): void {
    this.isSoftphoneOnlyGrant = this.securityService.validateGrant('SoftphoneOnly');
    if (this.securityService.validateGrant('SoftphoneOnly') != true) {
      const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
      this.isSoftphoneOnlyGrant = loginParams?.UseSoftPhone;
    }

   // console.log(this.isSoftphoneOnly, 'isSoftphoneOnly grant');
    if (!this.isSoftphoneOnlyGrant) {
      this.appService.isSoftPhoneUsed.subscribe(res => {
       // console.log(res);
        if (res) {
          this.isSoftphoneOnly = true;
        } else {
          this.isSoftphoneOnly = false;
        }
      });
    } else {
      this.isSoftphoneOnly = this.isSoftphoneOnlyGrant;
    }

    if (this.isSoftphoneOnly) {
      this.phoneTypes.push('Soft Phone', 'Hard Phone');
      this.selectedType = 'Soft Phone';
    } else {
      this.phoneTypes.push('Hard Phone');
      this.selectedType = 'Hard Phone';
    }

    this.addnewCampaignForm = new FormGroup({ activeStartTime: new FormControl(new Date()) });
    this.campaignDetail = {
      Start: '',
      End: '',
      RunningTime: '',
      CallsMade: '',
      Failures: '',
      Successes: '',
      Responses: '',
      processResult: '',
    };
    this.title = 'Add New Campaign';
    this.getCampaignTypes();
    this.getChannelTypes();
    this.getResponseQueues();
    this.getPhoneNumbers();
    this.getTimeZones();
    this.getIVRPromptAPIMethods();
    this.getSkills();
    this.getIVRPromptsByResponseQueue(null);
    this.availableOnDays = [
      { label: 'Sun', value: 1, checked: false },
      { label: 'Mon', value: 2, checked: false },
      { label: 'Tue', value: 4, checked: false },
      { label: 'Wed', value: 8, checked: false },
      { label: 'Thu', value: 16, checked: false },
      { label: 'Fri', value: 32, checked: false },
      { label: 'Sat', value: 64, checked: false },
    ];
    this.initForm();

    // Subscribe to value changes of the checkboxes
    this.addnewCampaignForm.valueChanges.subscribe(formValue => {
      //console.log('formValue', formValue);
      this.selectedDays = this.getSelectedValues(formValue.selectedDays);
      //console.log('Selected days:', this.selectedDays);
    });

    this.appService.ttsPlaying.subscribe(value => {
      value ? (this.previewBtnText = 'Playing') : (this.previewBtnText = 'Preview');
    });

    this.audio.addEventListener('loadstart', () => {
     // console.log('loadstart');
      this.previewBtnText = 'Loading';
    });
    this.audio.addEventListener('loadeddata', () => {
      this.previewBtnText = 'Preview';
     // console.log('loadeddata');
    });
    this.audio.addEventListener('playing', () => {
      this.previewBtnText = 'Playing';
    });
    this.audio.addEventListener('ended', () => {
      this.previewBtnText = 'Preview';
    });
    const user: any = this.webStorageService.getItemFromSessionStorage('currentUser');
    for (var i = 0, l = user.PhoneNumbers.length; i < l; i++) {
      this.txtphonenumber = user.PhoneNumbers[i].Number;
      this.smsPhoneNumber = user.PhoneNumbers[i].Number;
    }
    this.keypad = false;
  }

  private initForm(): void {
    this.addnewCampaignForm = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      crmCampaignID: [''],
      channel: ['', Validators.required],
      type: [''],
      callFrom: ['', Validators.required],
      activeDays: [''],
      activeStartTime: ['', Validators.required],
      activeEndTime: ['', Validators.required],
      activeTimeZone: ['', Validators.required],
      attempts: ['', Validators.required],
      attemptsInterval: ['', Validators.required],
      messageSource: ['', Validators.required],
      messageDescription: [''],
      playMessage: ['', Validators.required],
      actionKey: ['None'],
      responseSkill: [''],
      responseQueue: [''], // Conditional Required
      responseQueueIVRPrompts: [''], // Conditional Required
      responseRate: [''],
      campaignAction: [''],
      isDataFeed: [false, Validators.required],
      customLogging: [false],
      apiMethod: [''],
      MachineDetection: [false],
      messageText: ['', Validators.required],
      campaignDataType: ['', Validators.required],
      selectedDays: this.fb.array(this.createDayControls(), [this.validateDaysSelection]),
      ttsMessage: [''],     
    });
  }

  populateForm() {
    this.savedData = {
      name: this.campaignDetail?.Name,
      description: this.campaignDetail?.Description,
      crmCampaignID: this.campaignDetail?.CrmCampaignID,
      channel: this.campaignDetail?.Channel,
      // type: this.campaignDetail?.Type,
      type: this.campaignDetail?.CampaignTypeId,
      callFrom: this.campaignDetail?.CampaignRun?.OutboundPhoneNumber,
      activeDays: this.campaignDetail?.CampaignRun?.ActiveDays,
      activeStartTime: this.campaignDetail?.CampaignRun?.ActiveStartTime,
      activeEndTime: this.campaignDetail?.CampaignRun?.ActiveEndTime,
      activeTimeZone: this.campaignDetail?.CampaignRun?.ActiveTimeZone,
      attempts: this.campaignDetail?.CampaignRun?.AttemptsPerContact,
      attemptsInterval: this.campaignDetail?.CampaignRun?.AttemptRetryDelay,
      messageSource: this.campaignDetail?.IVRPrompt?.Description,
      messageDescription: this.campaignDetail?.IVRPrompt?.Message,
      playMessage: this.campaignDetail?.IVRPrompt?.Attributes?.loop,
      actionKey: this.campaignDetail?.IVRPrompt?.Attributes?.actionKey || 'None',
      responseSkill: this.campaignDetail?.CampaignRun?.ResponseSkillID,
      responseQueue: this.campaignDetail?.CampaignRun?.ResponseActivityID,
      responseQueueIVRPrompts: this.campaignDetail?.CampaignRun?.ResponsePromptID,
      responseRate: this.campaignDetail?.CampaignRun?.EstimatedResponseRate,
      campaignAction: '',
      isDataFeed: this.campaignDetail?.IsDataFeed,
      customLogging: this.campaignDetail?.CustomLogging || false,
      apiMethod: this.campaignDetail?.IVRPrompt?.ApiMethodID,
      MachineDetection: this.campaignDetail?.IVRPrompt?.Attributes?.IsMachineDetection || false,
      messageText: this.campaignDetail?.CampaignRun?.ResponsePrompt?.Message,
      campaignDataType: '',
      selectedDays: [],
      ttsMessage: '',
    };

    // Set messageText
    if (this.savedData.channel == 2) {
      // Text campaign
      this.tempMsg=this.campaignDetail.IVRPrompt.Message;
      this.savedData.messageText = this.campaignDetail.IVRPrompt.Message;
      this.savedData.messageSource =this.campaignDetail?.IVRPrompt?.Attributes?.MessageType || "false";       
    }

    if (this.campaignDetail?.IVRPrompt?.Description === 'texttospeech') {
      this.savedData.ttsMessage = this.campaignDetail?.IVRPrompt?.Message;
      this.disablePreviewBtn = false;
    }

    this.setAvailableOn();
    this.setTimeBetween();
    this.setDataType();
    this.formatRunningTime();
    this.addnewCampaignForm.patchValue(this.savedData);
   // console.log('this.savedData', this.savedData); 
    if (this.campaignDetail?.Status == 'Complete') {
      this.progress = 100;
    }

    // Validate
    this.validateTimeRange();
    this.onChannelChange();
    if (this.selectedChannel == 1) {
      //Voice
      this.onActionKeyChange();
      this.onAttemptsChange();
    }else{
      this.onTextSourceChange();
    }
    //this.onMessageSourceChange();
    this.hideShowPreviewButton(this.savedData.messageSource);
  }

  validateDaysSelection(control: FormGroup) {
    const selectedDays = control.value;
    const selectedCount = selectedDays?.filter(selected => selected).length;
    return selectedCount >= 1 ? null : { atLeastOneSelected: true };
  }

  createDayControls(): FormGroup[] {
    return this.availableOnDays.map(day => this.fb.control(day.checked));
  }

  getSelectedValues(daysArray: boolean[]): number[] {
    if (daysArray && daysArray.length > 0) {
      return this.availableOnDays.filter((day, index) => daysArray[index]).map(selectedDay => selectedDay.value);
    } else {
      return [];
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.addnewCampaignForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;
   // console.log(this.selectedDays);
    this.onChannelChange();
    this.onAttemptsChange();
    this.onActionKeyChange();
   // console.log(this.addnewCampaignForm);

    if (this.addnewCampaignForm.invalid) {
      if (
        this.selectedChannel == 1 &&
        (this.addnewCampaignForm.controls['messageSource'].status == 'INVALID' ||
          this.addnewCampaignForm.controls['playMessage'].status == 'INVALID')
      ) {
        // // this.errorVoiceMsg = "Please fill require fields to add a message"
        // if (this.router.url.includes('/New'))
        //   {
        this.showAddMessage = true;

        // }
        // // this.onActionKeyChange();
      }

      // const initialState = {
      //   contentMsg: 'Please fill all the required fields before proceeding further !!',
      //   confirmBtnValue: 'Ok',
      //   cancelBtnValue: '',
      //   isConfirm: true,
      //   isDelete: false,
      // };

      // const config: ModalOptions = {
      //   backdrop: 'static',
      //   class: 'confirm-dialog modal-wd-290',
      //   initialState,
      // };

      // this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
      // this.modalRef.content.event.subscribe((result: any) => {
      //   if (result.value == 'confirm') {
      //     console.log('create');
      //     this.modalRef.hide();
      //     // this.managerService.recordAdded.emit(res);
      //     // this.outboundComponent.loadQueues();
      //     // alert('hi')
      //     // this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
      //   }
      // });
      return;
    }

    const formData = this.addnewCampaignForm.value;
    const intFileds = [
      'id',
      'channel',
      'type',
      'activeDays',
      'activeStartTime',
      'activeEndTime',
      'attempts',
      'attemptsInterval',
      'responseSkill',
      'responseQueue',
      'responseQueueIVRPrompts',
      'responseRate',
      'apiMethod',       
    ];

    //Convert activeStartTime to a Date object
    if (formData.activeStartTime) {
     // console.log('start date is before:', typeof formData.activeStartTime, formData.activeStartTime);
      if (typeof formData.activeStartTime === 'string') {
        formData.activeStartTime = Utils.convertTime12to24(formData.activeStartTime);
      } else if (formData.activeStartTime instanceof Date) {
        formData.activeStartTime = Utils.convertTime12to24(formData.activeStartTime.toLocaleTimeString());
      }
     // console.log('start date is after:', formData.activeStartTime);
    }

    if (formData.activeEndTime) {
    //  console.log('end date is before:', typeof formData.activeEndTime, formData.activeEndTime);
      if (typeof formData.activeEndTime === 'string') {
        formData.activeEndTime = Utils.convertTime12to24(formData.activeEndTime);
      } else if (formData.activeEndTime instanceof Date) {
        formData.activeEndTime = Utils.convertTime12to24(formData.activeEndTime.toLocaleTimeString());
      }
    //  console.log('end date is after:', formData.activeEndTime);
    }
    // if (formData.activeStartTime && !(formData.activeStartTime instanceof Date)) {
    //   let parsedDate = new Date(formData.activeStartTime);
    //   if (!isNaN(Date.parse(formData.activeStartTime))) {
    //     formData.activeStartTime = parsedDate;
    //   }
    //   //formData.activeStartTime = new Date(formData.activeStartTime);
    // }

    // if (formData.activeEndTime && !(formData.activeEndTime instanceof Date)) {
    //   let parsedDate = new Date(formData.activeEndTime);
    //   if (!isNaN(Date.parse(formData.activeEndTime))) {
    //     formData.activeEndTime = parsedDate;
    //   }
    //   //formData.activeEndTime = new Date(formData.activeEndTime);
    // }
    // if (formData.activeStartTime instanceof Date) {
    //   if (typeof formData.activeStartTime === 'string') {
    //     formData.activeStartTime = Utils.convertTime12to24(formData.activeStartTime.toLocaleTimeString());
    //   } else {
    //     console.log('start date is invalid');
    //   }
    // }

    // if (formData.activeEndTime instanceof Date) {
    //   if (typeof formData.activeEndTime === 'string') {
    //     formData.activeStartTime = Utils.convertTime12to24(formData.activeStartTime.toLocaleTimeString());
    //   } else {
    //     console.log('start date is invalid');
    //   }
    // }
    // if (formData.activeEndTime === 'string' && !isNaN(Date.parse(formData.activeEndTime))) {
    //   formData.activeEndTime = new Date(formData.activeEndTime);
    // }

   // console.log('Form submitted:', formData, this.selectedDays);
    formData.activeDays = this.selectedDays?.reduce((accumulator, current) => accumulator + current);
    // formData.activeStartTime = Utils.convertTime12to24(formData.activeStartTime.toLocaleTimeString());
    // formData.activeEndTime = Utils.convertTime12to24(formData.activeEndTime.toLocaleTimeString());

    let message = 'New campaign created successfully';
    if (this.isEdit) {
      message = 'Campaign updated successfully';
      // Campaign id is needed to update
      formData.id = this.campaignDetail.ID;
    }

    // payload datatype check
    Object.entries(formData).forEach(([key, value]) => {
      //console.log('key-val', key, value);
      if (value && intFileds.includes(key)) {
        formData[key] = Number(value);
      }
    });

    formData.IsDataFeed = false;
    if (formData.campaignDataType === 'Data Feed') {
      formData.IsDataFeed = true;
    }

    if (this.selectedChannel === 2 || this.selectedChannel === '2') {
      formData["MessageType"]= formData.messageSource;      
      if(formData.messageSource == 'true'){
        formData.messageSource = 'custom';
      }else{
        formData.messageSource = formData.messageText;
      }
    } else {
      if (formData.messageSource === 'texttospeech') {
        formData.messageDescription = formData.ttsMessage;
      } else {
        formData.ttsMessage = '';
      }
      const tmp = formData.messageDescription;
      formData.messageDescription = formData.messageSource;
      formData.messageSource = tmp;
    }

    if (formData.actionKey == 'None' || formData.actionKey == '') {
      formData.actionKey = '-1';
       formData.responseQueue = null;
       formData.responseQueueIVRPrompts = null;
    }
    if (!formData.attempts || isNaN(formData.attempts)) {
      formData.attempts = 1;
    }

    this.campaignService.createCampaign(formData).subscribe(response => {
     // console.log('createCampaign response', response);
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: message,
      });
      this.goBackTimeout = setTimeout(() => {
        this.goBack();
      }, 1000);
    });
  }

  getTimeZones() {
    this.managerService.GetTimeZones().subscribe(response => {
      //console.log("GetTimeZones", response.Response.Data);
      response.Response.Data.forEach(element => {
        this.timeZones.push({ label: element.Name, value: element.ID });
      });
    });
  }

  getIVRPromptAPIMethods() {
    this.campaignService.getIVRPromptAPIMethods().subscribe(response => {
      //console.log("GetTimeZones", response.Response.Data);
      response.Response.Data.forEach(element => {
        this.ivrPromptAPIMethods.push({
          label: element.API + ' - ' + element.Name,
          value: element.MethodID,
        });
      });
    });
  }

  getUserRole(label: any) {
    if (label.lastIndexOf(' (Manager)') > -1) {
      return 2;
    } else return 1;
  }

  onChannelChange() {
    this.selectedChannel = this.addnewCampaignForm.get('channel').value;
   // console.log('this.selectedChannel', this.selectedChannel);

    // Following field(s) are not required for Voice Campaign
    const voiceChannelExcludeValidation = ['messageText'];
    if (this.selectedChannel == 1) {
      // Voice
      this.isTextChannelSelected = false;
      // this.showAddMessage = true;
      voiceChannelExcludeValidation.forEach(input => {
        this.addnewCampaignForm.controls[input].removeValidators(Validators.required);
        this.addnewCampaignForm.controls[input].setValue('');
        this.addnewCampaignForm.controls[input].updateValueAndValidity();

        // this.errorVoiceMsg = "Please fill require fields to add a message"
        // this.isValid = false;
      });
    } else {
      this.isTextChannelSelected = true;
      this.showAddMessage = false;
      voiceChannelExcludeValidation.forEach(input => {
        this.addnewCampaignForm.controls[input].addValidators(Validators.required);
        this.addnewCampaignForm.controls[input].updateValueAndValidity();
        // this.errorVoiceMsg = " "
      });
    }

    // Following fields are not needed for Text Campaign. Remove va;idation and reset field.
    // actionKey is also not needed, but it's optional field. So not included in the required validation exclusion list.
    const textChannelExcludeValidation = [ 'attempts', 'attemptsInterval', 'playMessage'];
    if (this.selectedChannel == 2) {
      // Text
      textChannelExcludeValidation.forEach(input => {
        this.addnewCampaignForm.controls[input].removeValidators(Validators.required);
        this.addnewCampaignForm.controls[input].setValue('');
        this.addnewCampaignForm.controls[input].updateValueAndValidity();
      });
      this.addnewCampaignForm.controls['actionKey'].setValue('');
    } else {
      textChannelExcludeValidation.forEach(input => {
        this.addnewCampaignForm.controls[input].addValidators(Validators.required);
        this.addnewCampaignForm.controls[input].updateValueAndValidity();
      });
    }
    // this.findRequiredControls();
    this.findInvalidControls();
  }

  goBack() {
    const clientAbbreviation = Utils.fetch('clientAbbreviation');
    this.router.navigate([clientAbbreviation + '/Console/Campaigns']);
  }

  startRecording() {
    this.savingRecordingFileMessage = '';
    if (!this.isRecording) {
      this.isRecording = true;
      this.audioRecordingService.startRecording();
    }
  }

  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopRecording() {
    this.savingRecordingFileMessage = 'Saving file...';
    if (this.isRecording) {
      this.audioRecordingService.stopRecording();
      this.isRecording = false;
      //this.download();

      this.stopRecordingTimeout = setTimeout(() => {
        this.loadAudio(this.blobUrl.changingThisBreaksApplicationSecurity);
        this.saveFile();
      }, 1000);
    }
  }

  clearRecordedData() {
    this.blobUrl = null;
  }

  ngOnDestroy(): void {
    this.abortRecording();
    this.stopRecordingTimeout && clearTimeout(this.stopRecordingTimeout);
    this.goBackTimeout && clearTimeout(this.goBackTimeout);
  }

  download(): void {
    const url = window.URL.createObjectURL(this.blobData?.blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.blobData.title;
    link.click();
  }

  saveFile() {
    if (
      this.addnewCampaignForm.get('messageSource').value === 'uploadfile' ||
      this.addnewCampaignForm.get('messageSource').value === 'recording'
    ) {
      this.isPublic = true;
    } else {
      this.isPublic = false;
    }
    this.campaignService.saveFile(this.blobData?.blob, this.isPublic).subscribe(response => {
     // console.log('saveFile', response);
      this.addnewCampaignForm.patchValue({
        messageDescription: response.Response.Data.URL,
      });
      this.savingRecordingFileMessage = response.Response.Data.URL.split('/').pop();
      this.clearRecordedData();
    });
  }

  handleFileInput(event) {
    this.savingAudioFileMessage = 'Saving File';
    //let input = event.target.files[0];
    const input = event.target;
    if (!input.files?.length) {
      this.savingAudioFileMessage = '';
      return;
    }

    const file = input.files[0];
    const fileExt = event.target.files[0].name.split('.').pop();
    const path = (window.URL || window.webkitURL).createObjectURL(file);
    //console.log('path', path, fileExt);

    if (fileExt === 'wav' || fileExt === 'mp3') {
      this.loadAudio(path); // for preview
    }
    if (
      this.addnewCampaignForm.get('messageSource').value === 'uploadfile' ||
      this.addnewCampaignForm.get('messageSource').value === 'recording'
    ) {
      this.isPublic = true;
    } else {
      this.isPublic = false;
    }
    this.campaignService.uploadFile(file, fileExt, this.isPublic, '').subscribe(response => {
     // console.log('saveFile', response);
      this.savingAudioFileMessage = 'File Saved';
      this.addnewCampaignForm.patchValue({
        messageDescription: response.Response.Data.URL,
      });
     // console.log(this.addnewCampaignForm.value);
      this.savingAudioFileMessage = response.Response.Data.URL.split('/').pop();
    });
  }

  getPhoneNumbers() {
    this.campaignService.getPhoneNumbers().subscribe(response => {
      //console.log("GetTimeZones", response.Response.Data);
      const unique = response.Response.Data?.filter((value, index, array) => array.indexOf(value) === index);
      unique.forEach(element => {
        this.phoneNumbers.push({ label: element, value: element });
      });
    });
  }

  setAvailableOn() {
    this.availableOnDays.forEach(day => {
      if (day.label === 'Sun' && (this.campaignDetail.CampaignRun.ActiveDays & 1) == 1) {
        day.checked = true;
      }
      if (day.label === 'Mon' && (this.campaignDetail.CampaignRun.ActiveDays & 2) == 2) {
        day.checked = true;
      }
      if (day.label === 'Tue' && (this.campaignDetail.CampaignRun.ActiveDays & 4) == 4) {
        day.checked = true;
      }
      if (day.label === 'Wed' && (this.campaignDetail.CampaignRun.ActiveDays & 8) == 8) {
        day.checked = true;
      }
      if (day.label === 'Thu' && (this.campaignDetail.CampaignRun.ActiveDays & 16) == 16) {
        day.checked = true;
      }
      if (day.label === 'Fri' && (this.campaignDetail.CampaignRun.ActiveDays & 32) == 32) {
        day.checked = true;
      }
      if (day.label === 'Sat' && (this.campaignDetail.CampaignRun.ActiveDays & 64) == 64) {
        day.checked = true;
      }
    });

    this.availableOnDays.forEach(day => {
      this.savedData.selectedDays.push(day.checked);
    });
  }

  loadCampaignDetails(id: number) {
    this.campaignService.getCampaignById(id).subscribe((data: any) => {
      this.campaignDetail = data.Response.Data;
      this.appService.setIsMachineDetection(data?.Response?.Data?.ClientAllowsMachineDetection);
      this.savedCampaignDetail = structuredClone(this.campaignDetail);
     // console.log('this.campaignDetail', this.campaignDetail);
      this.campaignDetail.IVRPrompt.Attributes.IsMachineDetection = JSON.parse(
        this.campaignDetail?.IVRPrompt?.Attributes?.IsMachineDetection.toLowerCase().toString()
      );
      this.title =
        'Group ' +
        this.campaignDetail.ID +
        ' - ' +
        this.campaignDetail.Name +
        (this.campaignDetail.Manager == null ? '' : ' (Manager: ' + this.campaignDetail.Manager + ')');
      this.appService.setSelectedCampaignName(this.title);
      this.details = {
        ID: this.campaignDetail.ID,
        owner: this.owner,
        object: this.object,
        service: this.managerService,
        method: 'GetGroupUsers',
        priorities: this.priorities,
        persistence: this.persistence,
        roles: this.roles,
        disable: !this.securityService.validateGrant('ManageAssignments'),
      };
      this.selectedChannel = this.campaignDetail.Channel;

      if (this.campaignDetail.ContactFileID) {
        this.getFilesById([this.campaignDetail.ContactFileID]);
      }
      this.getCampaignLoadStatus(this.selectedCampaignId);
      this.getIVRPromptsByResponseQueue(this.campaignDetail?.CampaignRun?.ResponseActivityID);
      const messageDescription = this.campaignDetail.IVRPrompt?.Description;
      const message = this.campaignDetail.IVRPrompt?.Message;
      const campaignStatus = this.campaignDetail?.Status;

      if (messageDescription === 'uploadfile' || messageDescription === 'recording') {
        // Get audio and load for preview
        if (message.includes('/s3/')) {
          //this.getAudioFileFromS3(message);
          this.loadAudio(message);
        } else {
          this.getAudioFile(message);
        }

        const fileName = message.split('/').pop();
        if (messageDescription === 'recording') this.savingRecordingFileMessage = fileName;
        else this.savingAudioFileMessage = fileName;
      }

     // console.log('this.campaignDetail?.Status', campaignStatus);
      let statuses = ['Pending', 'Ready', 'Paused'];

      if (!statuses.includes(campaignStatus)) {
        this.disableForm();
      }

      if (campaignStatus === 'Pending') {
        this.showAddMessage = false;
        //this.showEditMessage = true;
      }

      if (campaignStatus === 'InProgress') {
        this.disableRefreshButton = false;
      } else {
        this.disableRefreshButton = true;
      }

      this.populateForm();
    }),
      catchError(error => {
        return EMPTY;
      });
  }

  setTimeBetween() {
    this.savedData.activeStartTime = Utils.convertTo12HourFormat(this.campaignDetail.CampaignRun.ActiveStartTime);
    this.savedData.activeEndTime = Utils.convertTo12HourFormat(this.campaignDetail.CampaignRun.ActiveEndTime);
    this.addnewCampaignForm.patchValue({ activeStartTime: new Date(this.savedData.activeStartTime) });
    this.addnewCampaignForm.patchValue({ ActiveEndTime: new Date(this.savedData.ActiveEndTime) });
    // const parseDate = moment(this.savedData.activeStartTime, 'YYYY-MM-DD hh:mmA').toDate();
    // const parseEndDate = moment(this.savedData.ActiveEndTime, 'YYYY-MM-DD hh:mmA').toDate();
    // if (!isNaN(parseDate.getTime())) {
    //   this.addnewCampaignForm.patchValue({ activeStartTime: parseDate });
    // } else {
    //   console.log('Invalid date', this.savedData.activeStartTime);
    // }
    // if (!isNaN(parseEndDate.getTime())) {
    //   this.addnewCampaignForm.patchValue({ ActiveEndTime: parseEndDate });
    // } else {
    //   console.log('Invalid date', this.savedData.ActiveEndTime);
    // }
  }

  async getFilesById(ids: any[]) {
   // console.log('getfile by Id');
    const response = await lastValueFrom(this.campaignService.getFilesByID(ids));
    if (response?.Response?.Data) {
     // console.log('getFilesByID', response.Response.Data);
      this.uploadedFiles = response.Response.Data;
    }
    // this.campaignService.getFilesByID(ids).subscribe(response => {
    //     console.log('getFilesByID', response.Response.Data);
    //     this.uploadedFiles = response.Response.Data;
    // });
  }

  formatBytes(bytes) {
    return Utils.formatBytes(bytes);
  }

  formatRunningTime() {
    this.campaignDetail.RunningTime = Utils.convertSecondsToTime(this.campaignDetail?.RunningTime);
  }

  disableForm() {
    this.disableAllInputs = true;
    Object.keys(this.addnewCampaignForm.controls).forEach(ctrl => {
      //console.log('ctrl', ctrl);
      this.addnewCampaignForm.controls[ctrl].disable();
    });
  }

  getChannelTypes() {
    this.campaignService.getChannelTypes().subscribe(response => {
      response.Response.Data.forEach(element => {
        this.channels.push({ label: element.Name, value: element.ID });
      });
    });
  }

  getResponseQueues() {
    this.campaignService.getResponseQueues().subscribe(response => {
      response.Response.Data.forEach(element => {
        this.responseQueues.push({ label: element.Name, value: element.ID });
      });
    });
  }

  getSkills() {
    this.managerService.GetSkills().subscribe(response => {
      response.Response.Data.forEach(element => {
        this.responseSkills.push({ label: element.Name, value: element.ID });
      });
    });
  }

  getIVRPromptsByResponseQueue(activityID) {
    this.responseQueueIVRPrompts = [];
    this.campaignService.getIVRPromptsByResponseQueue(activityID).subscribe(response => {
      if (this.responseQueueIVRPrompts <= 0) {
        response.Response.Data.forEach(element => {
          this.responseQueueIVRPrompts.push({
            label: element.Name,
            value: element.ID,
            type: element.Type,
          });
        });
      }
    });
  }

  getPromptById(id) {
    this.responseQueueIVRPrompts.forEach(element => {
      if (element.value == id) return element.name;
    });
  }

  downloadFile(filePath): void {
   // console.log('downloadFile', filePath);
    this.triggerDownload(filePath);
  }
  downloadBase64File(item: any) {
    if (item?.URL.includes('s3')) {
      this.downloadFile(item?.URL);
    } else {
      this.managerService.getRecordingFiles(item.URL).subscribe(res => {
       // console.log('FileData', res);
        const src = `data:${res?.MimeType};base64,${res?.result}`;
        const link = document.createElement('a');
        link.href = src;
        link.download = res?.fileName;
        link.click();
        link.remove();
      });
    }
  }

  triggerDownload(filePath) {
    const url = filePath;
    const link = document.createElement('a');
    link.href = url;
    link.download = filePath.split('/').pop();
    link.click();
  }

  refresh() {
    this.loadCampaignDetails(this.selectedCampaignId);
  }

  async getCampaignLoadStatus(campaignId, eventId = null) {
    let processResult = '';
    this.campaignDetail.processResult = '';
    const resCampaignLoadStatus: any = await lastValueFrom(
      this.campaignService.getCampaignLoadStatus(campaignId, eventId)
    );
    if (resCampaignLoadStatus?.Response) {
      if (resCampaignLoadStatus.Response.Message == 'No CampaignLoad event found.') {
        this.dataFileProcessStatus = 'No Event';
        this.dataFileProcess = this.dataFileProcessStatus;
      } else {
        this.dataFileProcessStatus = resCampaignLoadStatus.Response?.Data?.Status; // Queued, In Progress, Completed
        this.dataFileProcess = this.dataFileProcessStatus;
      }

      if (this.dataFileProcessStatus === 'Completed') {
        if (resCampaignLoadStatus.Response?.Data?.Errors.length > 0) {
          resCampaignLoadStatus.Response.Data.Errors.forEach(element => {
            processResult += element + '\n';
          });
          this.campaignDetail.processResult = processResult;
          this.dataFileProcess = 'Completed - Invalid Data File';
        } else {
          this.dataFileProcess = 'Completed - Valid Data File';
          this.campaignDetail.TotalRecords = resCampaignLoadStatus.Response?.Data?.Successes;
        }
      }
    }
    // this.campaignService.getCampaignLoadStatus(campaignId, eventId).subscribe(response => {
    //     if (response.Response.Message == 'No CampaignLoad event found.') {
    //         this.dataFileProcessStatus = 'No Event';
    //         this.dataFileProcess = this.dataFileProcessStatus;
    //     } else {
    //         this.dataFileProcessStatus = response.Response?.Data?.Status; // Queued, In Progress, Completed
    //         this.dataFileProcess = this.dataFileProcessStatus;
    //     }

    //     if (this.dataFileProcessStatus === 'Completed') {
    //         if (response.Response?.Data?.Errors.length > 0) {
    //             response.Response.Data.Errors.forEach(element => {
    //                 processResult += element + '\n';
    //             });
    //             this.campaignDetail.processResult = processResult;
    //             this.dataFileProcess = 'Completed - Invalid Data File';
    //         } else {
    //             this.dataFileProcess = 'Completed - Valid Data File';
    //             this.campaignDetail.TotalRecords = response.Response?.Data?.Successes;
    //         }
    //     }
    // });
  }

  setDataType() {
    this.savedData.campaignDataType = 'File Upload';
    if (this.campaignDetail.IsDataFeed) {
      this.savedData.campaignDataType = 'Data Feed';
    }
  }

  getCampaignTypes() {
    this.campaignService.getCampaignTypes().subscribe(response => {
      response.Response.Data.forEach(element => {
        this.campaignTypes.push({ label: element.Name, value: element.ID });
      });
    });
  }

  pauseCampaign() {
    this.addnewCampaignForm.patchValue({ campaignAction: 'pause' });
    this.onSubmit();
  }

  resumeCampaign() {
    this.addnewCampaignForm.patchValue({ campaignAction: 'resume' });
    this.onSubmit();
  }

  cancelCampaign() {
    this.addnewCampaignForm.patchValue({ campaignAction: 'cancel' });
    this.onSubmit();
  }

  startCampaign() {
    this.addnewCampaignForm.patchValue({ campaignAction: 'start' });
    this.onSubmit();
  }

  onAttemptsChange() {
    const attempts = this.addnewCampaignForm.get('attempts').value;
    if (attempts == 1 || attempts == '') {
      this.addnewCampaignForm.controls['attemptsInterval'].removeValidators(Validators.required);
      this.addnewCampaignForm.controls['attemptsInterval'].updateValueAndValidity();
    } else {
      this.addnewCampaignForm.controls['attemptsInterval'].addValidators(Validators.required);
      this.addnewCampaignForm.controls['attemptsInterval'].updateValueAndValidity();
    }
  }

  findRequiredControls() {
    const requiredControls: string[] = [];
    // Loop through each control in the form group
    Object.keys(this.addnewCampaignForm.controls).forEach(controlName => {
      const control = this.addnewCampaignForm.get(controlName);
      if (control.validator) {
        requiredControls.push(controlName);
      }
    });
    //return requiredControls;
   // console.log('Required controls:');
    // requiredControls.forEach(controlName => {
    //   console.log(`- ${controlName}`);
    // });
  }

  findInvalidControls() {
    const invalid = [];
    const controls = this.addnewCampaignForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    //return invalid;
   // console.log('invalid', invalid);
  }

  showDetailsView() {
    this.appService.setSelectedCampaignId(this.selectedCampaignId);
    const clientAbbreviation = Utils.fetch('clientAbbreviation');
    this.router.navigate([clientAbbreviation + '/Console/Campaigns/View-Details/' + this.selectedCampaignId]);
    //this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
  }

  onActionKeyChange() {
    const actionKey = this.addnewCampaignForm.get('actionKey').value;
   // console.log('actionKey', actionKey);
    const excludeValidation = ['responseQueue', 'responseQueueIVRPrompts'];
    if (actionKey == 'None' || actionKey == '') {
      excludeValidation.forEach(input => {
        this.addnewCampaignForm.controls[input].removeValidators(Validators.required);
        this.addnewCampaignForm.controls[input].updateValueAndValidity();
      });
      this.addnewCampaignForm.patchValue({
        responseQueue: '',
        responseQueueIVRPrompts: ''
      });
    } 
    else 
    {
      excludeValidation.forEach(input => {
        this.addnewCampaignForm.controls[input].addValidators(Validators.required);
        this.addnewCampaignForm.controls[input].updateValueAndValidity();
      });
    }
  }
  validateTimeRange() {
    let startTime = this.addnewCampaignForm.get('activeStartTime').value;
    let endTime = this.addnewCampaignForm.get('activeEndTime').value;
    if (typeof endTime === 'string') {
      endTime = Utils.convertTime12to24(endTime);
    } else if (endTime instanceof Date) {
      endTime = Utils.convertTimes12to24(endTime.toLocaleTimeString());
    }
    if (typeof startTime === 'string') {
      startTime = Utils.convertTime12to24(startTime);
    } else if (startTime instanceof Date) {
      startTime = Utils.convertTimes12to24(startTime.toLocaleTimeString());
    }
    if (startTime && endTime && Number(startTime) > Number(endTime)) {
      this.timeValidationMessage = 'Invalid: End Time should be greater than Start Time';
      this.disableSaveBtn = true;
    } else if (startTime && endTime && startTime == endTime) {
      this.timeValidationMessage = 'Invalid: Start Time and End Time should not be same';
      this.disableSaveBtn = true;
    } else {
      this.timeValidationMessage = '';
      this.disableSaveBtn = false;
    }
  }
  previewMessage() {
    const messageSource = this.addnewCampaignForm.get('messageSource').value;
   // console.log('previewMessage messageSource', messageSource);

    if (messageSource === 'texttospeech') {
      this.speak(this.addnewCampaignForm.get('ttsMessage').value);
    }

    if (messageSource === 'uploadfile' || messageSource === 'recording') {
      this.audio.play();
    }
  }

  loadAudio(audioFilePath) {
   // console.log('loadAudio', audioFilePath);
    this.audio.src = audioFilePath;
    this.audio.load();
    this.disablePreviewBtn = false;
    this.previewBtnText = 'Preview';
  }

  onMessageSourceChange() {
    // If messageSource = tts, make message text mandatory
    // If messageSource = fileupload.recording, make messageDescription mandatory

    const messageSource = this.addnewCampaignForm.get('messageSource').value;
    this.lastSelectedMessageSource = this.addnewCampaignForm.get('messageSource').value;

    if (messageSource === 'texttospeech') {
      this.previewBtnText = 'Preview';
      this.disablePreviewBtn = false;
      this.addnewCampaignForm.controls['ttsMessage'].addValidators(Validators.required);
      this.addnewCampaignForm.controls['ttsMessage'].updateValueAndValidity();
      this.addnewCampaignForm.controls['messageDescription'].removeValidators(Validators.required);
      this.addnewCampaignForm.controls['messageDescription'].updateValueAndValidity();
    } else if (messageSource === 'recording' || messageSource === 'uploadfile') {
      this.savingAudioFileMessage = 'No file chosen';
      this.savingRecordingFileMessage = '';
      //this.savingRecordingFileMessage = this.savingAudioFileMessage = '';
      this.addnewCampaignForm.patchValue({ messageDescription: '' }); // Since messageDescription contains previously saved value & required validation will not work.

      this.addnewCampaignForm.controls['messageDescription'].addValidators(Validators.required);
      this.addnewCampaignForm.controls['messageDescription'].updateValueAndValidity();
      this.addnewCampaignForm.controls['ttsMessage'].removeValidators(Validators.required);
      this.addnewCampaignForm.controls['ttsMessage'].updateValueAndValidity();
    } else if (messageSource === 'apiMethod') {
      this.addnewCampaignForm.controls['messageDescription'].removeValidators(Validators.required);
      this.addnewCampaignForm.controls['messageDescription'].updateValueAndValidity();
      this.addnewCampaignForm.controls['ttsMessage'].removeValidators(Validators.required);
      this.addnewCampaignForm.controls['ttsMessage'].updateValueAndValidity();
    } else if (messageSource === 'customivrmessage') {
      this.addnewCampaignForm.controls['actionKey'].setValue('Default');

      this.addnewCampaignForm.controls['messageDescription'].removeValidators(Validators.required);
      this.addnewCampaignForm.controls['messageDescription'].updateValueAndValidity();
      this.addnewCampaignForm.controls['ttsMessage'].removeValidators(Validators.required);
      this.addnewCampaignForm.controls['ttsMessage'].updateValueAndValidity();
    }

    this.hideShowPreviewButton(messageSource);
    // this.showEditMessage = true;
  }

  hideShowPreviewButton(messageSource) {
    let tmp = false;
    this.messageSources.forEach(item => {
      if (item.value === messageSource && item.allowPreview) {
        tmp = true;
      }
    });
    this.showPreviewBtn = tmp;
   // console.log(messageSource, this.showPreviewBtn);
  }

  speak(text: string): void {
    this.ttsService.speak(text);
  }

  async handleDataFileInput(event) {
    this.savingDataFileMessage = 'Saving File';
    //let input = event.target.files[0];
    const input = event.target;
    if (!input.files?.length) {
      this.savingDataFileMessage = '';
      return;
    }

    const file = input.files[0];
    const fileExt = event.target.files[0].name.split('.').pop();
    const path = (window.URL || window.webkitURL).createObjectURL(file);
   // console.log('path', path);
    //if(this.addnewCampaignForm.get('messageSource').value === 'uploadfile' || (this.addnewCampaignForm.get('messageSource').value === 'recording') ){
    //  this.isPublic = true;
    //}else{
    //  this.isPublic = false;
    //}
    this.isPublic = false;
    // this.campaignService.uploadFile(file, fileExt, this.isPublic, this.selectedCampaignId).subscribe(saveFileResponse => {
    //     console.log('saveFile', saveFileResponse);
    //     this.savingDataFileMessage = 'File Saved';
    //     const fileID = saveFileResponse.Response.Data.FileID;
    //     this.getFilesById([fileID]);
    //     this.updateFile = !this.updateFile;
    //     this.campaignService.processDataFile(this.selectedCampaignId, fileID).subscribe(processDataFileResponse => {
    //         console.log('processDataFile', processDataFileResponse);
    //         this.getCampaignLoadStatus(this.selectedCampaignId,processDataFileResponse?.Response?.Data);
    //     });
    // });
    const resuploadFile: any = await lastValueFrom(
      this.campaignService.uploadFile(file, fileExt, this.isPublic, this.selectedCampaignId)
    );
    if (resuploadFile?.Response?.Data) {
    //  console.log('saveFile', resuploadFile);
      this.savingDataFileMessage = 'File Saved';
      const fileID = resuploadFile.Response.Data.FileID;
      await this.getFilesById([fileID]);
      this.updateFile = !this.updateFile;
      const resprocessDataFile: any = await lastValueFrom(
        this.campaignService.processDataFile(this.selectedCampaignId, fileID)
      );
      if (resprocessDataFile?.Response?.Data) {
        await this.getCampaignLoadStatus(this.selectedCampaignId, resprocessDataFile?.Response?.Data);
      }
    }
    setInterval(() => {
      // Keep checking till the dataFIleProcess status is not completed
      if (!(this.dataFileProcessStatus == 'Completed' || this.dataFileProcessStatus == 'No Event')) {
        this.getCampaignLoadStatus(this.selectedCampaignId);
      }
    }, 2000);
  }

  getAudioFile(filePath: string) {
    this.managerService.getRecordingFiles(filePath).subscribe(data => {
    //  console.log('getAudioFile', filePath, data);
      const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
      const binary = Utils.convertDataURIToBinary(binaryData);
      const blob = new Blob([binary], { type: data.MimeType });
      const blobUrl = URL.createObjectURL(blob);
      this.loadAudio(blobUrl);
    });
  }

  getAudioFileFromS3(filePath: string) {
    this.managerService.getFilesFromS3(filePath).subscribe(data => {
    //  console.log('getAudioFile', filePath, data);
      const blob = new Blob([data], { type: data.type });
      const blobUrl = URL.createObjectURL(blob);
      this.loadAudio(blobUrl);
    });
  }

  cancelMessageSourceEdit() {
    //messageSource: this.addnewCampaignForm.get('messageSource').value;
    this.addnewCampaignForm.setValue({
      messageSource: this.lastSelectedMessageSource,
    });
    //this.onMessageSourceChange();
    this.addnewCampaignForm.patchValue({
      messageSource: this.savedCampaignDetail?.IVRPrompt?.Description,
    });
    this.addnewCampaignForm.patchValue({
      messageDescription: this.savedCampaignDetail?.IVRPrompt?.Message,
    });

   // console.log('before patch values:', this.lastSelectedMessageSource);

    this.addnewCampaignForm.setValue({
      messageSource: this.addnewCampaignForm.get('messageSource').value,
      // messageSource: this.lastSelectedMessageSource,
    });

    // this.showEditMessage = false;
   // console.log('after patch values:', this.lastSelectedMessageSource);

    // Revert saved file name
    const fileName = this.savedCampaignDetail?.IVRPrompt?.Message.split('/').pop();
    if (this.savedCampaignDetail?.IVRPrompt?.Description === 'recording') this.savingRecordingFileMessage = fileName;
    else this.savingAudioFileMessage = fileName;

    // If tts selected & and then cancelled edit
    this.addnewCampaignForm.controls['ttsMessage'].removeValidators(Validators.required);
    this.addnewCampaignForm.controls['ttsMessage'].updateValueAndValidity();
    this.cdr.markForCheck();
  }

  private audioContext!: AudioContext;
  private mediaStream!: MediaStream;
  private sourceNode!: MediaStreamAudioSourceNode;
  private sourceNode1!: AudioBufferSourceNode;
  public isPlaying = false;
  public isTestcallPlaying = false;
  public callID = '';
  public isHardPhonePlaying = this.baseHref + '/assets/images/icon-dial-start.png';

  /*async startLiveAudio() {
        try {
            // Request access to the microphone
            this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });

            // Create an AudioContext
            this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

            // Create a source node from the microphone input
            this.sourceNode = this.audioContext.createMediaStreamSource(this.mediaStream);

            // Connect the source node to the destination (speakers)
            this.sourceNode.connect(this.audioContext.destination);

            this.isPlaying = true;
            console.log('Live audio playback started.');
        } catch (err) {
            console.error('Error accessing microphone: ', err);
        }
    }
    async startOwnAudio() {
        try {
            // Create an AudioContext
            this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

            // Load the audio file
            const response = await fetch(this.audio.src);
            const audioData = await response.arrayBuffer();

            // Decode the audio file
            this.audioBuffer = await this.audioContext.decodeAudioData(audioData);

            // Create a buffer source node
            this.sourceNode1 = this.audioContext.createBufferSource();
            this.sourceNode1.buffer = this.audioBuffer;

            // Connect to the destination (speakers)
            this.sourceNode1.connect(this.audioContext.destination);

            // Start playback
            this.sourceNode1.start(0);

            this.isPlaying = true;
            console.log('Custom audio playback started.');
            this.sourceNode1.onended = () => {
                this.isPlaying = false;
                this.isHardPhonePlaying = this.baseHref + '/assets/images/icon-dial-start.png';
            }
        } catch (err) {
            console.error('Error playing audio file:', err);
        }
    }
    stopOwnAudio() {
        try {
            if (this.sourceNode1) {
                this.sourceNode1.stop(); // Stop the audio playback
                this.sourceNode1.disconnect(); // Disconnect the node
                this.sourceNode1 = null; // Clear reference
            }

            if (this.audioContext) {
                this.audioContext.close(); // Close the AudioContext to free resources
                this.audioContext = null;
            }

            this.isPlaying = false;
            console.log('Custom audio playback stopped.');
            this.isHardPhonePlaying = this.baseHref + '/assets/images/icon-dial-start.png';
        } catch (err) {
            console.error('Error stopping audio playback:', err);
        }
    }

    // Stop the live audio playback
    stopLiveAudio() {
        if (this.mediaStream) {
            // Stop all audio tracks to stop microphone input
            this.mediaStream.getTracks().forEach(track => track.stop());
            this.isPlaying = false;
            console.log('Live audio playback stopped.');
        }

        if (this.audioContext) {
            // Close the AudioContext
            this.audioContext.close();
        }
    } */
  StartTestPhoneCall() {
    const formData = this.addnewCampaignForm.value;
    /*if (this.selectedType === 'Soft Phone') {
            if (formData.messageSource === 'texttospeech') {
                this.speak(this.addnewCampaignForm.get('ttsMessage').value);
            } else {
                if (this.isPlaying == true) {
                    this.isHardPhonePlaying = this.baseHref + '/assets/images/icon-dial-start.png';
                    this.cdr.detectChanges();
                    this.stopOwnAudio();
                } else {
                    this.isHardPhonePlaying = this.baseHref + '/assets/images/icon-dial-end.png';
                    this.cdr.detectChanges();
                    //this.startLiveAudio();
                   // this.startOwnAudio() 
                    let details = {
                        selectedCampaignId: this.selectedCampaignId,
                        phoneNumber: (this.phoneNumber == undefined || this.phoneNumber == null ? '' : this.phoneNumber),
                        formData: this.addnewCampaignForm.value,
                        CallType:'SoftPhone'
                    }
                    //this.campaignService.StartTestPhoneCall(details).subscribe(response => {
                    //    console.log(response.Response.Data + 'response save chagnes >>>>>>>>>');
                    //    this.checkTestCallInProgress(response.Response.Data);
                    //});

                }
            }
        } */
    if (this.isPlaying == false && this.isTestcallPlaying == false) {
      this.isHardPhonePlaying = this.baseHref + '/assets/images/icon-dial-end.png';
      this.cdr.detectChanges();
    //  console.log(this.isHardPhonePlaying);
      let details = {
        selectedCampaignId: this.selectedCampaignId,
        phoneNumber: this.phoneNumber == undefined || this.phoneNumber == null ? '' : this.phoneNumber,
        formData: this.addnewCampaignForm.value,
        CallType: this.selectedType === 'Soft Phone' ? 'SoftPhone' : this.selectedType,
      };
      this.campaignService.StartTestPhoneCall(details).subscribe(response => {
        if (this.selectedType === 'Soft Phone') {
          this.isPlaying = true;
          this.calloptionWidth = 'calloption-soft-phone';
          this.txtphonenumberwidth = 'soft-phone';
          this.startTimer();
          //this.phoneNumber = this.formattedCallDuration;
          this.cdr.detectChanges();
        }
        if (this.selectedType === 'Hard Phone') {
          this.isTestcallPlaying = true;
        }
       // console.log(response.Response.Data + 'response save chagnes >>>>>>>>>');
        this.checkTestCallInProgress(response.Response.Data);
        this.callID = response.Response.Data;
      });
    } else if (this.isTestcallPlaying == true) {
      this.campaignService.cancelTestCall(this.callID).subscribe(response => {
        this.isTestcallPlaying = true;
       // console.log(response.Response.Data + 'response save chagnes >>>>>>>>>');
      });
    } else {
      this.StopCall();
    }
  }
  StopCall() {
    this.MainControllerComponent.endCall(null, null);
    this.isPlaying = false;
    this.isTestcallPlaying = false;
    this.calloptionWidth = 'calloption-hard-phone';
    this.txtphonenumberwidth = 'hard-phone';
    clearInterval(this.callTimer);
    this.callTimer = '';
    this.phoneNumber = '';
    this.keypad = false;
  }
  checkTestCallInProgress(callID) {
    this.callerIdInterval = setInterval(() => {
      if (callID != null) {
        this.campaignService.IsTestCallInProgress(callID).subscribe(response => {
         // console.log(response + 'response save chagnes >>>>>>>>>');
          if (response.Response.Data === true) {
            this.cdr.detectChanges();
          } else {
            this.isHardPhonePlaying = this.baseHref + '/assets/images/icon-dial-start.png';
            this.calloptionWidth = 'calloption-hard-phone';
            this.txtphonenumberwidth = 'hard-phone';
            this.isPlaying = false;
            this.isTestcallPlaying = false;
            this.keypad = false;
            clearInterval(this.callTimer);
            this.callTimer = '';
            this.phoneNumber = '';
            this.cdr.detectChanges();
            clearInterval(this.callerIdInterval);
          }
        });
      } else {
        clearInterval(this.callerIdInterval);
      }
    }, 2000);
  }
  onSelectionChange(event: any) {
    this.selectedType = event.target.value;
    ['', 'Hard Phone'];
    if (this.selectedType === 'Soft Phone') {
      this.phoneNumber = '';
      this.isReadOnly = true;
    } else {
      this.phoneNumber = this.txtphonenumber;
      this.isReadOnly = false;
    }
  }
  numbersOnly(event) {
    const input = String.fromCharCode(event.keyCode);
    if (!/^[0-9+]*$/.test(input)) {
      event.preventDefault();
      alert('Enter Valid Phonenumber!');
    }
  }
  sendSMS() {
    let data = {
      callFrom: this.addnewCampaignForm?.value?.callFrom,
      callTo: this.smsPhoneNumber,
      callToType: this.addnewCampaignForm?.value?.type,
      messageText: this.addnewCampaignForm?.value?.messageText,
      IVRPromptId:  this.addnewCampaignForm?.value?.responseQueueIVRPrompts    
    };
    let messageSource= this.addnewCampaignForm?.value?.messageSource;//this.addnewCampaignForm.get('messageSource').value; 
    if(messageSource=="true"){
      this.campaignService.SendTestCustomText(data).subscribe(res => {
        console.log('Campaign_Custom_Send SMS:', res);
      });
    }
    else{
    this.campaignService.SendTestText(data).subscribe(res => {
      console.log('Campaign_Send SMS:', res);
    });
  }
    //SendTestCustomText
  }

  messagePromptSettingsCancel() {
    this.showAddMessage = false;
    //this.savingAudioFileMessage = 'No file chosen';
  }
  mute(isMicMute) {
    this.isMicMute = !isMicMute;
    this.MainControllerComponent.muteUnmuteMic(this.isMicMute);
   // console.log('isMicMute', this.isMicMute);
  }

  unmute() {
    this.isMicMute = false;
    this.MainControllerComponent.muteUnmuteMic(this.isMicMute);
   // console.log('isMicMute', this.isMicMute);
  }
  showKeypad() {
    this.keypad = !this.keypad;
   // console.log(this.keypad);
  }
  onNumberPadBtnClick(value) {
    var tone;
    //AWS Migration - ONV-1456 ( Hardcoded s3bucket name of AWS environment )
    switch (value) {
      case '#':
        tone = new Audio('https://common.cts-connect.com/Audio/pound.wav');
        break;
      case '*':
        tone = new Audio('https://common.cts-connect.com/Audio/star.wav');
        break;
      default:
        tone = new Audio('https://common.cts-connect.com/Audio/' + value + '.wav');
    }
    tone.play();

    this.appService.setNumberpadValue(value);
    // this.numberPadKeyPressedHandler(value)
  }
  startTimer() {
    this.callDuraton = 0;
    this.callTimer = setInterval(() => {
      this.callDuraton++;
      this.phoneNumber = this.formatCallDuration(this.callDuraton);
    }, 1000);
   // console.log(this.formattedCallDuration + 'calldurationinnewcampa');
  }

  formatCallDuration(seconds) {
    const hoursLeft = Math.floor(seconds / 3600);
    const min = Math.floor((seconds - hoursLeft * 3600) / 60);
    let secondsLeft = seconds - hoursLeft * 3600 - min * 60;
    secondsLeft = Math.round(secondsLeft * 100) / 100;
    let answer = ':' + (min < 10 ? '0' + min : min);
    answer += ':' + (secondsLeft < 10 ? '0' + secondsLeft : secondsLeft);
    return answer;
  }

  cancelPreview() {
    const messageSource = this.addnewCampaignForm.get('messageSource').value;
    if (messageSource === 'texttospeech') {
      this.ttsService.stop();
    }
    if (messageSource === 'uploadfile' || messageSource === 'recording') {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
    this.previewBtnText = 'Preview';
  }
  onTextSourceChange(){
    let messageSource=this.addnewCampaignForm.get('messageSource').value; 
    let txt='messageText';
    this.addnewCampaignForm.get(txt).enable();
    if(messageSource=="true"){
      this.tempMsg=this.addnewCampaignForm.get(txt).value;
      this.addnewCampaignForm.get(txt).setValue(''); 
      this.addnewCampaignForm.get(txt).disable();
      this.addnewCampaignForm.controls[txt].removeValidators(Validators.required);
    }else {
      this.addnewCampaignForm.get('responseQueueIVRPrompts').setValue(''); 
      this.addnewCampaignForm.get(txt).setValue(this.tempMsg); 
      this.addnewCampaignForm.controls[txt].addValidators(Validators.required);
    }
  }
}
